import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'lifedi-question-most-least',
  templateUrl: './question-most-least.component.html',
  styleUrls: ['./question-most-least.component.scss']
})
export class QuestionMostLeastComponent implements OnInit {
  @Input() mostLeastForm: FormGroup;
  @Input() isEditValue: boolean;
  @Output() media = new EventEmitter();
  @Output() qMedia = new EventEmitter();
  @Output() qMediaType = new EventEmitter();

  modalData: any;
  choicesMedia = [];
  questionMediaType: string;
  questionMedia;
  vdoDuration;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private gbFunction: GobalFunctionService
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    if (this.isEditValue) {
      // console.log(this.modalData);
      // console.log(this.mostLeastFormArray.value);
      this.questionMediaType = this.modalData.value.VALUE[0].media.media_type;

      for (let i = 0; i < this.modalData.value.VALUE[0].choices.length; i++) {
        this.mostLeastFormArray.push(
          this.fb.group({
            choice_id: [this.modalData.value.VALUE[0].choices[i].choice_id, Validators.required],
            choice_detail: [this.modalData.value.VALUE[0].choices[i].choice_detail, Validators.required]
          })
        )
        this.mostLeastForm.controls['media'].setValue(this.modalData.value.VALUE[0].media);

      }
    }
  }

  getDuration(e) {
    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      window.URL.revokeObjectURL(video.src);
      this.vdoDuration = video.duration;
      // alert("Duration : " + video.duration + " seconds");
    }
    video.src = URL.createObjectURL(e.target.files[0]);
  }

  addQuestionMedia(e, form) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);
    this.questionMediaType = fileType;
    // // console.log(fileType);
    // console.log(form);

    if (fileType === 'mp4') {
      this.getDuration(e);
    }

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg' || fileType === 'mp3' || fileType === 'mp4' || fileType === 'wav') {
      setTimeout(() => {
        if (e.target.files && e.target.files[0]) {
          const file = (e.target as HTMLInputElement).files[0];
          const type = (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') ? 'image' : (fileType === 'mp3' || fileType === 'wav') ? 'sound' : 'vdo'

          form.controls['media'].patchValue({
            media_type: type,
            file_name: file.name,
            unlimit: '',
            time_again: '',
            duration: this.vdoDuration,
            vdo_id: '',
            file_url: ''
          });

          form.controls['media'].updateValueAndValidity();
          this.questionMedia = file;
          this.qMedia.emit(this.questionMedia);
          this.qMediaType.emit(this.questionMediaType);
        }
      }, 1000);
    } else {
      alert('การอัปโหลดรองรับไฟล์ JPG, JPEG, PNG, MP3, MP4, WAV เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  addChoice(form) {
    form.push(
      this.fb.group({
        choice_id: form.value.length + 1,
        choice_detail: ['', Validators.required]
      })
    );
  }

  deleteImgQuestion(form) {
    this.questionMedia = '';
    this.questionMediaType = '';

    form.get('media').reset({
      media_type: '',
      file_name: '',
      time_again: '',
      unlimit: '',
      file_url: ''
    });
    this.qMedia.emit(this.questionMedia);
    this.qMediaType.emit(this.questionMediaType);
  }

  get mostLeastFormArray(): FormArray {
    return this.mostLeastForm.get('choices') as FormArray;
  }

  deleteChoice(form, index) {
    form.removeAt(index);

    form.value.map((f, index) => {
      f.choice_id = index + 1;
    })
  }

  clearValueDate(form) {
    if (!form.value.media.unlimit) {
      form.get('media').patchValue({ time_again: '' });
    }
  }

  setTimeAgain(form, e) {
    if (e.target.value > 0)
      form.get('media').patchValue({ time_again: e.target.value });
    else
      form.get('media').patchValue({ time_again: 0 });
  }
}
